import dayjs from "dayjs";
import { DaysWeek } from "../../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs";
import { FrequencyEnum } from "../components/steps/configCalendar/enums";
import { InputModel } from "../../../../../utils/types";
import { Box, Grid } from "@mui/material";

export const frequencies = [
    {
        label: 'Única vez',
        value: FrequencyEnum.UNIQUE,
    },
    {
        label: 'Diaria',
        value: FrequencyEnum.DAYLI,
    },
    {
        label: 'Semanal',
        value: FrequencyEnum.WEEKLY,
    },
    {
        label: 'Cíclica',
        value: FrequencyEnum.CYCLIC,
    },
]

export const frequenciesWithOuytUnique = [
    {
        label: 'Diaria',
        value: FrequencyEnum.DAYLI,
    },
    {
        label: 'Semanal',
        value: FrequencyEnum.WEEKLY,
    },
    {
        label: 'Cíclica',
        value: FrequencyEnum.CYCLIC,
    },
]

export const daysOfWeek = [
    { label: 'Lunes', value: DaysWeek.MONDAY },
    { label: 'Martes', value: DaysWeek.TUESDAY },
    { label: 'Miércoles', value: DaysWeek.WEDNESDAY },
    { label: 'Jueves', value: DaysWeek.THURSDAY },
    { label: 'Viernes', value: DaysWeek.FRIDAY },
    { label: 'Sábado', value: DaysWeek.SATURDAY },
    { label: 'Domingo', value: DaysWeek.SUNDAY },
]

export const today = dayjs().format('YYYY-MM-DDTHH:mm');

export const inputOneDaily: { [x: string]: InputModel } = ({
    startDateDaily: {
        label: 'general.tags.initHour',
        translate: true,
        name: 'startDateDaily',
        type: 'time',
        rest: {
            max: 'endDateDaily',
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    },
    endDateDaily: {
        label: 'general.tags.endHour',
        translate: true,
        name: 'endDateDaily',
        type: 'time',
        rest: {
            min: 'startDateDaily',
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    }
})

export const inputSecondDaily: { [x: string]: InputModel } = ({
    fromDateDaily: {
        label: 'general.tags.from',
        translate: true,
        name: 'fromDateDaily',
        type: 'date',
        value: null,
        staticMin: true,
        rest: {
            max: 'toDateDaily',
            min: today
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    },
    toDateDaily: {
        label: 'general.tags.to',
        translate: true,
        name: 'toDateDaily',
        type: 'date',
        value: null,
        rest: {
            min: 'fromDateDaily',
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    },
})

export const inputSecondCycli: { [x: string]: InputModel } = ({
    fromDateCycli: {
        label: 'general.tags.from',
        translate: true,
        name: 'fromDateCycli',
        type: 'date',
        value: null,
        staticMin: true,
        rest: {
            max: 'toDateCycli',
            min: today
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    },
    toDateCycli: {
        label: 'general.tags.to',
        translate: true,
        name: 'toDateCycli',
        type: 'date',
        value: null,
        rest: {
            min: 'fromDateCycli',
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    },
})

export const inputOneWeekly: { [x: string]: InputModel } = ({
    /* startDate: {
        label: 'general.tags.openingTime',
        translate: true,
        name: 'startDate',
        type: 'time',
        validate: {
            required: true,
        },
        size: {
            xl: 4,
            lg: 4,
            md: 4,
            sm: 4,
        },
    }, */
    duration: {
        label: 'general.tags.duration',
        translate: true,
        name: 'duration',
        validate: {
            required: true,
            /* number: true,
            decimal: false */
        },
        type: 'numberWithText',
        rest: {
            /* type: 'number',
            min: 1, */
            // max: 255,
        },
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
        wrapChildren: ({ children, id }) => {
            return (<>
                <Box sx={{minHeight:'70px',alignContent:'center'}}>
                    <Box sx={{'& .MuiInputBase-root':{height:'70px'}, '& .MuiFormLabel-root':{ top:'8px' } }}>{children}</Box>
                </Box>
            </>
            )
        }
    },
    /* endDate: {
        label: 'general.tags.closingTime',
        translate: true,
        name: 'endDate',
        type: 'time',
        validate: {
            required: true,
        },
        size: {
            xl: 4,
            lg: 4,
            md: 4,
            sm: 4,
        },
    } */
})

export const inputDailySerie: { [x: string]: InputModel } = ({
    fromDateDaily: {
        label: 'general.tags.executionDay',
        translate: true,
        name: 'fromDateDaily',
        type: 'date',
        value: null,
        staticMin: true,
        rest: {
            min: today
        },
        validate: {
            required: true,
        },
        size: {
            xl: 12,
            lg: 12,
            md: 12,
            sm: 12,
        },
        wrapChildren: ({ children, id }) => {
            return (<>
                <Grid container>
                    <Grid item xs={6}>{children}</Grid>
                </Grid>
            </>
            )
        }
    },
    startDateDaily: {
        label: 'general.tags.initHour',
        translate: true,
        name: 'startDateDaily',
        type: 'time',
        rest: {
            max: 'endDateDaily',
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    },
    endDateDaily: {
        label: 'general.tags.endHour',
        translate: true,
        name: 'endDateDaily',
        type: 'time',
        rest: {
            min: 'startDateDaily',
        },
        validate: {
            required: true,
        },
        size: {
            xl: 6,
            lg: 6,
            md: 6,
            sm: 6,
        },
    }
})

